import type { Notification } from "./types";

const text = (value: unknown) => typeof value === "string" ? value : "";

export function notificationTarget(notification: Notification) {
  if (notification.templateCode.startsWith("appointment_")) return "/agenda";
  if (notification.templateCode === "weekly_schedule_summary") {
    const from = text(notification.payload.from);
    const to = text(notification.payload.to);
    return from && to ? `/agenda?from=${from}&to=${to}` : "/agenda";
  }
  if (notification.templateCode === "quote_accepted") return "/orcamentos";
  if (notification.templateCode === "payment_overdue") return "/financeiro";
  if (notification.templateCode === "inventory_below_minimum") return "/estoque";
  if (notification.templateCode === "work_order_started" || notification.templateCode === "work_order_completed") {
    const id = text(notification.payload.workOrderId);
    return id ? `/ordens/${id}` : "/ordens";
  }
  if (notification.templateCode === "work_order_document_pending") {
    const id = text(notification.payload.workOrderId);
    return id ? `/ordens/${id}` : "/ordens";
  }
  return "/ordens";
}
